import api from '../../ApiConfig';
import { Apis } from '../../config';
var token = localStorage.getItem('userToken');

const updateLinnworkShippingAddress = async (orderId, data) => {
    try {

      let result = await api.put(`${Apis.UpdateShippingAddress+orderId}`, data, {
          headers: {
            'x-access-token': token
          }
        });
    
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
      return null;
    }
  };

const updateLinnworkBillingAddress = async (orderId, data) => {
    try {

      let result = await api.put(`${Apis.UpdateBillingAddress+orderId}`, data, {
          headers: {
            'x-access-token': token
          }
        });
    
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
      return null;
    }
  };



  const exportedObject = {
    updateLinnworkShippingAddress,
    updateLinnworkBillingAddress
};
export default exportedObject;